export default {
    9004: "L''email ou le mot de passe est incorrect, veuillez réessayer.",
}